"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppLink_1 = __importDefault(require("./AppLink"));
var getCDN_1 = require("./utils/getCDN");
function AppStoreLogo(props) {
    var _a = props.region, region = _a === void 0 ? 'US' : _a;
    var path = (0, getCDN_1.getCDN)(region) + "/assets/components/footer";
    return (react_1.default.createElement(AppLink_1.default, __assign({}, props, { alt: "app store", srcSet: path + "/app-store.png 1x,\n      " + path + "/app-store@2x.png 2x,\n      " + path + "/app-store@3x.png 3x", src: path + "/app-store@3x.png" })));
}
exports.default = AppStoreLogo;
